// NextScene — shared country / dial-code / language reference data.
// Used by CastTalent and Advertise forms. Alphabetically sorted; "Other" is
// treated as a special option and rendered outside these arrays.

export const COUNTRIES = [
  "Afghanistan","Albania","Algeria","Argentina","Armenia","Australia","Austria","Azerbaijan",
  "Bahrain","Bangladesh","Belarus","Belgium","Bhutan","Bolivia","Bosnia and Herzegovina","Brazil","Bulgaria",
  "Cambodia","Cameroon","Canada","Chile","China","Colombia","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic",
  "Denmark","Dominican Republic","Ecuador","Egypt","Estonia","Ethiopia",
  "Finland","France","Georgia","Germany","Ghana","Greece","Guatemala",
  "Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy",
  "Japan","Jordan","Kazakhstan","Kenya","Kuwait","Latvia","Lebanon","Libya","Lithuania","Luxembourg",
  "Macau","Malaysia","Maldives","Mali","Malta","Mauritius","Mexico","Moldova","Monaco","Mongolia","Morocco","Myanmar",
  "Nepal","Netherlands","New Zealand","Nigeria","Norway","Oman",
  "Pakistan","Panama","Paraguay","Peru","Philippines","Poland","Portugal","Qatar",
  "Romania","Russia","Rwanda","Saudi Arabia","Senegal","Serbia","Singapore","Slovakia","Slovenia","South Africa","South Korea","Spain","Sri Lanka","Sweden","Switzerland","Syria",
  "Taiwan","Tanzania","Thailand","Tunisia","Türkiye","UAE","Uganda","Ukraine","United Kingdom","United States","Uruguay","Uzbekistan",
  "Venezuela","Vietnam","Yemen","Zambia","Zimbabwe",
];

// Dial codes with flag + name. Sorted by country name.
export const DIAL_CODES = [
  { name: "Afghanistan",       code: "+93",  flag: "🇦🇫" },
  { name: "Albania",           code: "+355", flag: "🇦🇱" },
  { name: "Algeria",           code: "+213", flag: "🇩🇿" },
  { name: "Argentina",         code: "+54",  flag: "🇦🇷" },
  { name: "Australia",         code: "+61",  flag: "🇦🇺" },
  { name: "Austria",           code: "+43",  flag: "🇦🇹" },
  { name: "Bahrain",           code: "+973", flag: "🇧🇭" },
  { name: "Bangladesh",        code: "+880", flag: "🇧🇩" },
  { name: "Belgium",           code: "+32",  flag: "🇧🇪" },
  { name: "Brazil",            code: "+55",  flag: "🇧🇷" },
  { name: "Cambodia",          code: "+855", flag: "🇰🇭" },
  { name: "Canada",            code: "+1",   flag: "🇨🇦" },
  { name: "Chile",             code: "+56",  flag: "🇨🇱" },
  { name: "China",             code: "+86",  flag: "🇨🇳" },
  { name: "Colombia",          code: "+57",  flag: "🇨🇴" },
  { name: "Czech Republic",    code: "+420", flag: "🇨🇿" },
  { name: "Denmark",           code: "+45",  flag: "🇩🇰" },
  { name: "Egypt",             code: "+20",  flag: "🇪🇬" },
  { name: "Ethiopia",          code: "+251", flag: "🇪🇹" },
  { name: "Finland",           code: "+358", flag: "🇫🇮" },
  { name: "France",            code: "+33",  flag: "🇫🇷" },
  { name: "Germany",           code: "+49",  flag: "🇩🇪" },
  { name: "Ghana",             code: "+233", flag: "🇬🇭" },
  { name: "Greece",            code: "+30",  flag: "🇬🇷" },
  { name: "Hong Kong",         code: "+852", flag: "🇭🇰" },
  { name: "Hungary",           code: "+36",  flag: "🇭🇺" },
  { name: "India",             code: "+91",  flag: "🇮🇳" },
  { name: "Indonesia",         code: "+62",  flag: "🇮🇩" },
  { name: "Ireland",           code: "+353", flag: "🇮🇪" },
  { name: "Israel",            code: "+972", flag: "🇮🇱" },
  { name: "Italy",             code: "+39",  flag: "🇮🇹" },
  { name: "Japan",             code: "+81",  flag: "🇯🇵" },
  { name: "Jordan",            code: "+962", flag: "🇯🇴" },
  { name: "Kazakhstan",        code: "+7",   flag: "🇰🇿" },
  { name: "Kenya",             code: "+254", flag: "🇰🇪" },
  { name: "Kuwait",            code: "+965", flag: "🇰🇼" },
  { name: "Malaysia",          code: "+60",  flag: "🇲🇾" },
  { name: "Mexico",            code: "+52",  flag: "🇲🇽" },
  { name: "Morocco",           code: "+212", flag: "🇲🇦" },
  { name: "Myanmar",           code: "+95",  flag: "🇲🇲" },
  { name: "Nepal",             code: "+977", flag: "🇳🇵" },
  { name: "Netherlands",       code: "+31",  flag: "🇳🇱" },
  { name: "New Zealand",       code: "+64",  flag: "🇳🇿" },
  { name: "Nigeria",           code: "+234", flag: "🇳🇬" },
  { name: "Norway",            code: "+47",  flag: "🇳🇴" },
  { name: "Oman",              code: "+968", flag: "🇴🇲" },
  { name: "Pakistan",          code: "+92",  flag: "🇵🇰" },
  { name: "Peru",              code: "+51",  flag: "🇵🇪" },
  { name: "Philippines",       code: "+63",  flag: "🇵🇭" },
  { name: "Poland",            code: "+48",  flag: "🇵🇱" },
  { name: "Portugal",          code: "+351", flag: "🇵🇹" },
  { name: "Qatar",             code: "+974", flag: "🇶🇦" },
  { name: "Russia",            code: "+7",   flag: "🇷🇺" },
  { name: "Saudi Arabia",      code: "+966", flag: "🇸🇦" },
  { name: "Singapore",         code: "+65",  flag: "🇸🇬" },
  { name: "South Africa",      code: "+27",  flag: "🇿🇦" },
  { name: "South Korea",       code: "+82",  flag: "🇰🇷" },
  { name: "Spain",             code: "+34",  flag: "🇪🇸" },
  { name: "Sri Lanka",         code: "+94",  flag: "🇱🇰" },
  { name: "Sweden",            code: "+46",  flag: "🇸🇪" },
  { name: "Switzerland",       code: "+41",  flag: "🇨🇭" },
  { name: "Taiwan",            code: "+886", flag: "🇹🇼" },
  { name: "Thailand",          code: "+66",  flag: "🇹🇭" },
  { name: "Türkiye",           code: "+90",  flag: "🇹🇷" },
  { name: "UAE",               code: "+971", flag: "🇦🇪" },
  { name: "Ukraine",           code: "+380", flag: "🇺🇦" },
  { name: "United Kingdom",    code: "+44",  flag: "🇬🇧" },
  { name: "United States",     code: "+1",   flag: "🇺🇸" },
  { name: "Uzbekistan",        code: "+998", flag: "🇺🇿" },
  { name: "Vietnam",           code: "+84",  flag: "🇻🇳" },
];

export const LANGUAGES = [
  "Arabic","Bengali","English","French","German","Gujarati","Hindi","Indonesian","Italian",
  "Japanese","Kannada","Korean","Malayalam","Mandarin Chinese","Marathi","Persian",
  "Portuguese","Punjabi","Russian","Spanish","Tamil","Telugu","Thai","Turkish","Urdu","Vietnamese",
];
